import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { IOrganizationInsuranceSection } from 'interfaces/insurance';

const name = 'organizationInsuranceSectionsV2';

export const fetchOrganizationInsuranceSectionsV2 = createAsyncThunk(
  `${name}/fetch`,
  async (organizationId: string, { dispatch }) => {
    try {
      const { data } = await axios.get<IOrganizationInsuranceSection[]>(
        `/api/questionnaire/v1/organizationInsuranceSections`,
        {
          params: {
            orderBy: 'organizationName asc',
            filter: `earliestPolicyExpirationDate ne 'null'`,
            organizationId
          }
        }
      );
      return data;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  organizationInsuranceSectionsV2: IOrganizationInsuranceSection[];
};

const initialState: State = {
  organizationInsuranceSectionsV2: [],
  isFetching: false,
  error: null
};

const organizationInsuranceSectionsV2 = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchOrganizationInsuranceSectionsV2.pending, isFetching)
      .addCase(fetchOrganizationInsuranceSectionsV2.fulfilled, (state, action) => {
        state.organizationInsuranceSectionsV2 = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchOrganizationInsuranceSectionsV2.rejected, error);
  }
});

export const { reducer: organizationInsuranceSectionsV2Reducer } = organizationInsuranceSectionsV2;
